import { render, staticRenderFns } from "./ParcoursThumbnail.vue?vue&type=template&id=32899f5a&scoped=true&"
import script from "./ParcoursThumbnail.vue?vue&type=script&lang=js&"
export * from "./ParcoursThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./ParcoursThumbnail.vue?vue&type=style&index=0&id=32899f5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32899f5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VIcon,VSkeletonLoader})
